var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c("w-select", {
        staticClass: "mr",
        staticStyle: { "flex-grow": "1" },
        attrs: { items: _vm.items, fancy: "", label: _vm.$ct("add-prop") },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
      _c(
        "w-button",
        {
          staticStyle: { "flex-shrink": "0" },
          on: {
            click: function ($event) {
              return _vm.add()
            },
          },
        },
        [_c("w-fa", { attrs: { icon: "plus" } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }